export default __webpack_public_path__ + "static/media/zupee.d10d546e.png";